import React, { useEffect, useState } from 'react'
import {
  AuthType,
  // EmbedEvent,
  init,
  // RuntimeFilterOp,
} from '@thoughtspot/visual-embed-sdk'
import {
  LiveboardEmbed,
  useEmbedRef,
} from '@thoughtspot/visual-embed-sdk/lib/src/react'

import { errorToast } from 'common/components/toastNotification'

const THOUGHT_SPOT_BASE_URL = 'https://jacquard.thoughtspot.cloud'
const CONNECT_INTERNAL = process.env.REACT_APP_CONNECT_INTERNAL_END_POINT

interface Props {
  vizId: string
  userId: string
}

const ThoughspotGraph = ({ vizId, userId }: Props) => {
  const ref = useEmbedRef<typeof LiveboardEmbed>()
  const [isLoading, setIsLoading] = useState(true)
  const [hasError, setHasError] = useState(false)
  const [isInitialized, setIsInitialized] = useState(false)

  useEffect(() => {
    const USER_TOKEN_URL = `v1/thoughtspot/users/${userId}/token`
    try {
      init({
        thoughtSpotHost: THOUGHT_SPOT_BASE_URL,
        authType: AuthType.TrustedAuthTokenCookieless,
        authEndpoint: `${CONNECT_INTERNAL}/${USER_TOKEN_URL}`,
      })
      setIsInitialized(true)
    } catch (error) {
      setHasError(true)
      errorToast('Failed to initialize ThoughtSpot. Please try again.')
    } finally {
      setIsLoading(false)
    }
  }, [userId])

  return (
    <div
      style={{
        height: 600,
        backgroundColor: '#f6efe0',
      }}
    >
      {isLoading && <div>Loading...</div>}
      {hasError && <div>Unable to load visualization</div>}
      {isInitialized && !hasError && (
        <LiveboardEmbed
          style={{
            border: '1px solid #E0C797',
            borderRadius: '2px',
          }}
          frameParams={{
            height: 600,
            width: '100%',
          }}
          ref={ref}
          liveboardId="9da415e7-ed80-484d-a3a7-f8a7bda53911"
          vizId={vizId}
          runtimeFilters={
            [
              // {
              //   columnName: 'Campaign Id',
              //   operator: RuntimeFilterOp.EQ,
              //   values: ['647f3d0985104f000843fe11'],
              // },
            ]
          }
          visibleActions={[]}
          onLoad={() => {}}
          onLiveboardRendered={() => {}}
          customizations={{
            style: {
              customCSS: {
                variables: {
                  '--ts-var-viz-background': '#f6efe0',
                },
              },
            },
          }}
        />
      )}
    </div>
  )
}

export default ThoughspotGraph
